var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Instagram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BandSite",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Instagram",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C17.7569111,0 20,2.24308892 20,5 L20,15 C20,17.7569111 17.7569111,20 15,20 L5,20 C2.24308892,20 0,17.7569111 0,15 L0,5 C0,2.24308892 2.24308892,0 5,0 L15,0 Z M18.4615385,15 L18.4615385,5 C18.4615385,3.09119592 16.9088041,1.53846154 15,1.53846154 L5,1.53846154 C3.09119592,1.53846154 1.53846154,3.09119592 1.53846154,5 L1.53846154,15 C1.53846154,16.9088041 3.09119592,18.4615385 5,18.4615385 L15,18.4615385 C16.9088041,18.4615385 18.4615385,16.9088041 18.4615385,15 Z M9.99981109,4.56692913 C12.9958302,4.56692913 15.4330709,7.00408514 15.4330709,10 C15.4330709,12.9959149 12.9958302,15.4330709 9.99981109,15.4330709 C7.00416981,15.4330709 4.56692913,12.9959149 4.56692913,10 C4.56692913,7.00408507 7.00416988,4.56692913 9.99981109,4.56692913 Z M9.99981109,13.8856223 C12.1423614,13.8856223 13.8855685,12.1424758 13.8855685,10 C13.8855685,7.85752416 12.1423614,6.11437772 9.99981109,6.11437772 C7.85726075,6.11437772 6.11443153,7.85752416 6.11443153,10 C6.11443153,12.1424758 7.85726075,13.8856223 9.99981109,13.8856223 Z M15.4330709,2.36220472 C15.8671413,2.36220472 16.2204724,2.71553583 16.2204724,3.1496063 C16.2204724,3.58367677 15.8671413,3.93700787 15.4330709,3.93700787 C14.9990004,3.93700787 14.6456693,3.58367677 14.6456693,3.1496063 C14.6456693,2.71553583 14.9990004,2.36220472 15.4330709,2.36220472 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.8d8c7e5d4c559d9713b4932c9bcbe2a3.svg";
export { ForwardRef as ReactComponent };